import { ReactElement } from 'react'

import { Select, Spin } from 'antd'

import { getProductAdsSearch } from 'api/Cerebro/orgScoped/amazonAdsApi'
import { SEARCH_RESULTS_PER_QUERY } from 'configuration/typeahead'
import { useTypeahead } from 'hooks'
import { ProductAdSearchResult } from 'types'

interface Props {
    value?: string
    onChange: (value: string) => void
}

const ProductAdSearchSelect = ({ value, onChange }: Props): ReactElement => {
    const [options, loading, onSearch, resetLoadingState] =
        useTypeahead<ProductAdSearchResult>({
            apiSearchFunc: (query) =>
                getProductAdsSearch(
                    {
                        limit: SEARCH_RESULTS_PER_QUERY,
                        asin__istartswith: query.trim(),
                    },
                    { headers: { noCount: true } }
                ),
            optionFormatter: (productAd) => ({
                value: productAd.id,
                label: productAd.asin,
                metadata: productAd.campaign__name,
            }),
        })

    return (
        <Select
            filterOption={false}
            placeholder="Search Product Ads by ASIN..."
            loading={loading}
            notFoundContent={loading ? <Spin size="small" /> : null}
            onChange={onChange}
            onSearch={onSearch}
            onSelect={resetLoadingState}
            showSearch
            style={{ width: '100%' }}
            value={value}
        >
            {options.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                    {option.label} <i>({option.metadata})</i>
                </Select.Option>
            ))}
        </Select>
    )
}

export default ProductAdSearchSelect
